const consts = {
	PRODUCT: {
		DIALER: 1,
		CALLCENTER: 2,
		PBX: 4,
		CRM: 8,
		TOOLBAR: 16,
		is: function(product, current) {
			return (current & product) > 0;
		}
	}
};

export default consts;
